import { Observable, timeout } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { OccEndpointsService } from '@spartacus/core';

import { RepairStoreFinderSearchPage } from '../models';

@Injectable({
  providedIn: 'root'
})
export class RepairService {
  constructor(private occEndpointService: OccEndpointsService, private httpClient: HttpClient) {}

  getRepairers(latitude: number, longitude: number, isCheckout: boolean, features: string[], posTypes: string[]): Observable<RepairStoreFinderSearchPage> {
    const url = this.occEndpointService.buildUrl('repairers', {
      queryParams: {
        showMode: 'ALL',
        radius: 2000,
        latitude,
        longitude,
        query: '',
        features: isCheckout ? 'Reparation_forfaitaire_prepayee' : features,
        posTypes
      }
    });

    return this.httpClient.get<RepairStoreFinderSearchPage>(url).pipe(timeout(5000));
  }
}
